import { HttpContextToken } from '@angular/common/http';

export const SkipByRefreshInterceptor = new HttpContextToken(() => true);
